"use client";

import type { VisibilityProps } from "./types";

function Visibility({ id, shouldShow, children }: VisibilityProps) {
  if (shouldShow === false) {
    return null;
  }

  return children;
}

export default Visibility;
